const SET_MODULES = 'SET_MODULES'
const SET_VIEWED_SHOP_MODULES = 'SET_VIEWED_SHOP_MODULES'

const initialState = {
    modules: [],
    viewedShopModules: []
}

export default {
    namespaced: true,

    state: initialState,

    getters: {
        modules: (state) => state.modules,
        viewedShopModules: (state) => state.viewedShopModules
    },

    actions: {
        loadModules({ commit }) {
            return new Promise((resolve, reject) => {
                window.axios.get('get/active-modules').then((response) => {
                    commit(SET_MODULES, response.data.modules)
                    resolve(response)
                }).catch((err) => {
                    reject(err)
                })
            })
        },

        // Modules d'une boutique précise consultée en gestion (Détail boutique,
        // ...), distincts de la boutique "active" de vente — voir modules
        loadShopModules({ commit }, shopId) {
            return new Promise((resolve, reject) => {
                window.axios.get('get/active-modules', { params: { shop_id: shopId } }).then((response) => {
                    commit(SET_VIEWED_SHOP_MODULES, response.data.modules)
                    resolve(response)
                }).catch((err) => {
                    reject(err)
                })
            })
        }
    },

    mutations: {
        [SET_MODULES](state, modules) {
            state.modules = Array.isArray(modules) ? modules : []
        },
        [SET_VIEWED_SHOP_MODULES](state, modules) {
            state.viewedShopModules = Array.isArray(modules) ? modules : []
        }
    }
}
